<template>
  <div class="">
    <b-card no-body class="border-none pl-12">
      <div class="mb-4">
        <div v-if="showInputBox">
          <div
            class="post-input mt-3"
            v-for="Reply in commentReplies[commentId] || []"
            :key="Reply._id"
          >
            <div class="">
              <div class="m-auto w-full">
                <div class="flex items-center">
                  <!-- <img
                    alt="user"
                    class="w-8 rounded-full"
                    :src="`${$imageURL}/${Reply._profile.image}`"
                  /> -->

                  <!-- <b-avatar variant="info" class="p-3 cust-avatar"></b-avatar> -->
                  <img
                    alt="user"
                    class="rounded-full w-8 h-8"
                    :src="`${$imageURL}/${Reply._user.userImage}`"
                    v-if="
                      Reply._user.hasOwnProperty('userImage') &&
                      Reply._user.userImage !== 'null' &&
                      Reply._user.userImage !== '' &&
                      Reply._user.userImage !== null
                    "
                  />
                  <b-avatar
                    v-else
                    variant="info "
                    class="p-2 text-xl cust-avatar"
                    size="lg"
                  ></b-avatar>
                  <div class="bgf4f5f6 rounded-lg px-4 py-2 w-full ml-3">
                    <div class="flex justify-between items-center">
                      <h1
                        class="font-semibold text-sm"
                        v-if="userData != null && !userData.isAnonymous"
                      >
                        {{ Reply._user.firstname }} {{ Reply._user.lastname }}
                      </h1>
                      <h1
                        class="font-semibold text-sm"
                        v-if="userData != null && userData.isAnonymous"
                      >
                        Anonymous User
                      </h1>
                      <!-- <b-dropdown
                        size="lg"
                        variant="link"
                        toggle-class="text-decoration-none py-2 px-0"
                        no-caret
                        dropleft
                      >
                        <template #button-content>
                          <feather-icon
                            class="cursor-pointer"
                            icon="ChevronDownIcon"
                            svgClasses="w-4 h-4"
                          ></feather-icon>
                        </template>
                        <b-dropdown-item href="#">Leave</b-dropdown-item>
                        <b-dropdown-item href="#">Edit</b-dropdown-item>
                        <b-dropdown-item href="#">Delete</b-dropdown-item>
                      </b-dropdown> -->
                      <b-dropdown
                        size="lg"
                        variant="link"
                        toggle-class="text-decoration-none py-2 px-0"
                        no-caret
                        dropleftb
                      >
                        <template #button-content>
                          <feather-icon
                            class="cursor-pointer"
                            icon="MoreHorizontalIcon"
                            svgClasses="w-4 h-4"
                          ></feather-icon>
                        </template>
                        <!-- <b-dropdown-item href="#">Leave</b-dropdown-item> -->
                        <!--   <b-dropdown-item href="#"
                          ><div class="flex">
                            <div class="w-1/6 m-auto">
                              <feather-icon
                                icon="EditIcon"
                                class="darktext w20px"
                              ></feather-icon>
                            </div>
                            <div class="w-5/6">
                              <p class="text-base darktext">Edit</p>
                            </div>
                          </div></b-dropdown-item
                        >-->
                        <b-dropdown-item
                          href="#"
                          v-if="userData._id == Reply._user._id"
                          ><div class="flex">
                            <div class="w-1/6 m-auto">
                              <feather-icon
                                icon="Trash2Icon"
                                class="darktext w20px"
                              ></feather-icon>
                            </div>
                            <div class="w-5/6" @click="deleteReply(Reply)">
                              <p class="text-base darktext">Delete</p>
                            </div>
                          </div></b-dropdown-item
                        >
                        <b-dropdown-item href="#"
                          ><div class="flex">
                            <div class="w-1/6 m-auto">
                              <feather-icon
                                icon="FlagIcon"
                                class="darktext w20px"
                              ></feather-icon>
                            </div>
                            <div class="w-5/6" @click="reportReply(Reply._id)">
                              <p class="text-base darktext">Report</p>
                            </div>
                          </div></b-dropdown-item
                        >
                        <!--
                        <b-dropdown-item href="#"
                          ><div class="flex">
                            <div class="w-1/6 m-auto">
                              <feather-icon
                                icon="FlagIcon"
                                class="darktext w20px"
                              ></feather-icon>
                            </div>
                            <div class="w-5/6">
                              <p class="text-base darktext">Report</p>
                            </div>
                          </div></b-dropdown-item
                        >-->
                      </b-dropdown>
                    </div>
                    <p class="text-sm text-muteddark font-normal">
                      {{ Reply.comment }}
                    </p>
                  </div>
                </div>
                <div class="flex items-center m-auto w-83per mt-2">
                  <p
                    class="text-xs font-bold mr-2 cursor-pointer hover:underline"
                  >
                    <LikeReply
                      liketype="Reply"
                      :commentID="Reply._id"
                      :commentData="Reply"
                      @like="likereply"
                    />
                  </p>
                  <!-- <p
                    class="
                      text-xs
                      font-bold
                      mr-2
                      cursor-pointer
                      hover:underline
                    "
                  >
                    Reply
                  </p> -->
                  <p class="text-xs font-medium">
                    {{ commentTime(Reply.createdAt) }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="flex items-center justify-between w-full pt-6 pb-2">
            <h2 class="font-semibold text-sm hover:underline cursor-pointer">
              View more comment
            </h2>
            <p class="text-sm font-medium">21 of 212</p>
          </div> -->
        </div>
        <div class="post-input mt-3" v-if="showInputBox">
          <div class="flex items-center">
            <b-avatar variant="info" class="p-2.5 cust-avatar"></b-avatar>
            <div class="flex relative w-full">
              <b-input
                v-model="reply"
                :value="reply"
                @keypress.enter="addReply()"
                class="ml-5 border-1 rounded-full"
                placeholder="Type a reply......"
              />
              <div
                class="absolute right-6 cursor-pointer pt-2.5 font-semibold text-sm"
                @click="addReply()"
              >
                Reply
              </div>
            </div>
          </div>
        </div>
        <!-- <div role="tablist" class="accordion mt-2">
          <b-card no-body class="mb-1">
            <b-card-header
              header-tag="header"
              href="#"
              role="tab"
              v-b-toggle.accordion-1
              class="p-4 cursor-pointer"
            >
              <div class="flex justify-between">
                <h5 class="mb-0 text-md texta9a9a9">
                  Organic impressions: 0 Impressions
                </h5>
                <div class="flex items-center">
                  <p class="font-medium text-sm pr-3 texta9a9a9">Show Stats</p>
                  <feather-icon icon="ChevronDownIcon" svgClasses="w-4 h-4" />
                </div>
              </div>
            </b-card-header>
            <b-collapse
              id="accordion-1"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <div class="title">
                  <span class=" font-medium cust-greycolor">Organic stats</span>
                  <p class="cust-greydark text-sm">
                    Targeted to: All followers
                  </p>
                </div>

                <div class="flex mt-4 flex-wrap justify-between">
                  <div class="p-3">
                    <p class="cust-greydark font-bold fsize20">0</p>
                    <p class="cust-greydark">Impressions</p>
                  </div>

                  <div class="p-3">
                    <p class="cust-greydark font-bold fsize20">0</p>
                    <p class="cust-greydark">Reactions</p>
                  </div>

                  <div class="p-3">
                    <p class="cust-greydark font-bold fsize20">0</p>
                    <p class="cust-greydark">Comments</p>
                  </div>

                  <div class="p-3">
                    <p class="cust-greydark font-bold fsize20">0</p>
                    <p class="cust-greydark">Shares</p>
                  </div>

                  <div class="p-3">
                    <p class="cust-greydark font-bold fsize20">27.78%</p>
                    <p class="cust-greydark">Engagement rate</p>
                  </div>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div> -->
      </div>
    </b-card>
  </div>
</template>

<script>
import FeatherIcon from "../../../components/FeatherIcon.vue";
import LikeReply from "./LikeReply.vue";
import { mapState } from "vuex";
export default {
  components: { FeatherIcon },
  props: {
    commentId: {
      type: String,
    },
    postId: {
      type: String,
    },
    showInputBox: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    LikeReply,
  },
  data() {
    return {
      reply: "",
    };
  },
  methods: {
    commentTime(time) {
      const distanceInWordsToNow = require("date-fns/distance_in_words_to_now");
      return `${distanceInWordsToNow(time)} ago`;
    },
    async addReply() {
      let Reply = {
        postId: this.postId,
        commentId: this.commentId,
        comment: this.reply,
      };
      let loader = this.$loading();
      try {
        await this.$store.dispatch("posts/addReply", Reply);
        this.reply = "";
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
    async reportReply(id) {
      let loader = this.$loading();
      try {
        let data = await this.$store.dispatch("posts/editComment", {
          commentID: id,
          reported: "yes",
        });
        if (data.code === 200) {
          this.$swal("Reported!", "Comment reply has been reported", "success");
        }
        loader.close();
      } catch (error) {
        loader.close();
        console.log(error);
      }
    },
    async deleteReply(Reply) {
      let loader = this.$loading();
      try {
        let Payload = {
          postId: this.postId,
          ...Reply,
        };
        await this.$store.dispatch("posts/deleteReply", Payload);
        this.$forceUpdate();
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
    likereply() {
      this.$forceUpdate();
    },
  },
  mounted() {
    // console.log(this.commentReplies);
  },
  computed: {
    ...mapState("posts", {
      commentReplies: "commentReplies",
    }),
    ...mapState("auth", {
      userData: "user",
    }),
  },
};
</script>
